function normalizeTeamKey(value) {
	return (value || '').toString().trim().toLowerCase();
}

function getWeekMatchup(team, week) {
	if (!team?.weeks) return null;
	return team.weeks[week] || team.weeks[String(week)] || null;
}

function formatPlayerNames(names) {
	if (names.length <= 1) return names[0] || '';
	if (names.length === 2) return `${names[0]} and ${names[1]}`;
	return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;
}

function getEntryFavorability(entry, week) {
	const favorabilities = entry?.favorabilities || {};
	return favorabilities[week] ?? favorabilities[String(week)] ?? null;
}

export function buildConflictNotes(players, weeks, teamLookup) {
	if (!players || players.length < 2) return [];

	const byeConflicts = [];
	const unfavorableConflicts = [];

	weeks.forEach((week) => {
		const onBye = [];
		const unfavorable = [];

		players.forEach((entry) => {
			if (!entry) return;

			const scheduleTeam = teamLookup[normalizeTeamKey(entry.team_name)] || null;
			if (scheduleTeam && !getWeekMatchup(scheduleTeam, week)) {
				onBye.push(entry.full_name);
			}

			if (getEntryFavorability(entry, week) === 'unfavorable') {
				unfavorable.push(entry.full_name);
			}
		});

		if (onBye.length >= 2) {
			byeConflicts.push({
				key: `bye-${week}`,
				ok: false,
				text: `${formatPlayerNames(onBye)} share a bye in Week ${week}`
			});
		}

		if (unfavorable.length >= 2) {
			unfavorableConflicts.push({
				key: `unfavorable-${week}`,
				ok: false,
				text: `${formatPlayerNames(unfavorable)} share an unfavorable matchup in Week ${week}`
			});
		}
	});

	const notes = [];

	if (byeConflicts.length > 0) {
		notes.push(...byeConflicts);
	} else {
		notes.push({
			key: 'bye-ok',
			ok: true,
			text: 'No shared bye weeks'
		});
	}

	if (unfavorableConflicts.length > 0) {
		notes.push(...unfavorableConflicts);
	} else {
		notes.push({
			key: 'unfavorable-ok',
			ok: true,
			text: 'No shared unfavorable matchups'
		});
	}

	return notes;
}
